import styled from 'styled-components';
import { variables } from '../../../../styles/variables';

export const Mark = styled('span')`
  display: flex;
  align-items: center;
  em {
    color: ${variables.colorGrey};
    font-size: 1.8rem;
  }
  @media (max-width: 1500px) and (min-width: 769px), (max-width: 1024px) {
    em {
      font-size: 1.5rem;
    }
  }
`;
